import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";

export default function VisitTracker() {
  const location = useLocation();
  useEffect(() => {
    api.post("/track/visit", { path: location.pathname }).catch(() => {});
  }, [location.pathname]);
  return null;
}
